<template>
  <MainLayout v-if="!isFullScreenRoute">
    <router-view />
  </MainLayout>
  <router-view v-else />
  <Snackbar />
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useCacheStore } from '@/stores/cache'
import { CACHE_VERSION } from '@/config/cache'
import MainLayout from '@/layouts/MainLayout.vue'
import Snackbar from '@/components/Snackbar.vue'

const route = useRoute()
const cacheStore = useCacheStore()
const isAuthRoute = computed(() => route.path.startsWith('/auth'))
const isFullScreenRoute = computed(() => isAuthRoute.value || route.meta.fullScreen)

// Récupérer l'environnement et le titre depuis les variables d'environnement
const title = import.meta.env.VITE_APP_TITLE || 'ETHICC App'

// Mettre à jour le titre au montage
onMounted(() => {
  // Mettre à jour le titre de la page
  document.title = title
  
  // Vérifier et vider le cache si la version a changé
  const cacheCleared = cacheStore.checkAndClearOnVersionChange(CACHE_VERSION)
  
  // Si le cache a été vidé, forcer un rechargement complet de la page
  if (cacheCleared) {
    // Petit délai pour que le log s'affiche
    setTimeout(() => {
      window.location.reload()
    }, 100)
  }
})
</script>

<style>
@import '@/assets/styles/colors.css';
@import '@/assets/styles/fonts.css';

body {
  margin: 0;
  background: var(--layout-background);
  color: var(--text-defaut);
  font-size: 14px;
}

* {
  box-sizing: border-box;
}
</style>